import * as React from 'react';
import { ReportTypeEnum } from "../enums";
import { translate } from "@js/common/helpers";
var DescriptionBlock = function (_a) {
    var type = _a.type;
    return (React.createElement("div", { className: "text-center mt-4 mb-2 col-12 mt-md-5 mb-md-4 col-md-6 mx-auto" },
        React.createElement("p", { className: "mb-0 lead" }, type === ReportTypeEnum.Premium ? translate('report.description.premium', {}, 'app') : translate('report.description.flash', {}, 'app'))));
};
export { DescriptionBlock };
